// extracted by mini-css-extract-plugin
export var avatarContainer = "_4z-0";
export var avatarTypingWave = "_4z-i";
export var gray = "_4z-f";
export var green = "_4z-c";
export var icon = "_4z-9";
export var image = "_4z-1";
export var lg = "_4z-6";
export var md = "_4z-5";
export var presenceDot = "_4z-b";
export var red = "_4z-d";
export var sm = "_4z-4";
export var status = "_4z-a";
export var typingDot = "_4z-h";
export var typingPill = "_4z-g";
export var xl = "_4z-7";
export var xs = "_4z-3";
export var xxl = "_4z-8";
export var xxs = "_4z-2";
export var yellow = "_4z-e";